import { generateClient, get, post } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";
import { CognitoIdentityServiceProvider } from "aws-sdk";
import {
	GroupType,
	UserType,
} from "aws-sdk/clients/cognitoidentityserviceprovider";
const client = generateClient();
export default class AdminService {
	private constructor() {}

	static async addUserToGroup(username: string, groupname: string) {
		const myInit = {
			body: {
				username,
				groupname,
			},
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};
		return post({
			apiName: "AdminQueries",
			path: "/addUserToGroup",
			options: myInit,
		});
	}

	static async removeUserFromGroup(username: string, groupname: string) {
		const myInit = {
			body: {
				username,
				groupname,
			},
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};
		return post({
			apiName: "AdminQueries",
			path: "/removeUserFromGroup",
			options: myInit,
		});
	}

	static async listGroups() {
		const myInit = {
			queryStringParameters: {
				limit: 60,
				token: undefined as undefined | string,
			},
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};

		const groups = [] as GroupType[];
		do {
			const rest = get({
				apiName: "AdminQueries",
				path: "/listGroups",
				options: myInit,
			}) as CognitoIdentityServiceProvider.ListGroupsResponse;
			myInit.queryStringParameters.token = rest.NextToken;
			groups.push(...(rest.Groups as GroupType[]));
		} while (myInit.queryStringParameters.token !== undefined);

		return groups as CognitoIdentityServiceProvider.GroupListType;
	}

	static async getGroupsForUser(username: string) {
		const myInit = {
			queryStringParameters: {
				username,
				limit: 60,
				token: undefined as undefined | string,
			},
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};

		const groups = [] as GroupType[];
		do {
			const rest = get({
				apiName: "AdminQueries",
				path: "/listGroupsForUser",
				options: myInit,
			}) as CognitoIdentityServiceProvider.ListGroupsResponse;
			myInit.queryStringParameters.token = rest.NextToken;
			groups.push(...(rest.Groups as GroupType[]));
		} while (myInit.queryStringParameters.token !== undefined);
		return groups as CognitoIdentityServiceProvider.GroupListType;
	}

	static async listUsers() {
		const myInit = {
			queryStringParameters: {
				limit: 60,
				token: undefined as undefined | string,
			},
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};

		const users = [] as UserType[];
		do {
			const rest = (await get({
				apiName: "AdminQueries",
				path: "/listUsers",
				options: myInit,
			})) as CognitoIdentityServiceProvider.Types.ListUsersResponse;
			// @ts-ignore
			myInit.queryStringParameters.token = rest.NextToken;
			users.push(...(rest.Users as UserType[]));
		} while (myInit.queryStringParameters.token !== undefined);
		return users;
	}

	static async createGroup(
		groupname: string,
		description?: string,
		precedence?: number
	) {
		const myInit = {
			body: JSON.stringify({
				groupname,
				description,
				precedence,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};
		return post({
			apiName: "AdminQueries",
			path: "/createGroup",
			options: myInit,
		}) as CognitoIdentityServiceProvider.CreateGroupResponse;
	}

	static async deleteGroup(groupname: string) {
		const myInit = {
			body: {
				groupname,
			},
			headers: {
				"Content-Type": "application/json",
				Authorization: `${(
					await fetchAuthSession()
				).tokens?.idToken?.toString()}`,
			},
		};
		return post({
			apiName: "AdminQueries",
			path: "/deleteGroup",
			options: myInit,
		}) as CognitoIdentityServiceProvider.CreateGroupResponse;
	}
}
